// extracted by mini-css-extract-plugin
export default {"exit-survey":"DTnJH_","modal":"NNituG","modal-header":"bTIq8h","close-button":"sjRACq","modal-content-with-bg":"iJ2IMz","modal-body":"HnaQbx","modal-footer":"bpfaJk"};